import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Nepomembnost",
  "description": "",
  "published": "2007-02-02T00:00:00.000Z",
  "redirect_from": ["/blog/nepomembnost/swizec/296"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V preteklosti se je clovestvo pojmovalo za najpomembnejsi dejavnik v vesolju. Vse zvezde so krozile okoli zemlje in enako je veljalo za vsa nebesna telesa. Potem pa je na sceno stopil Nikolaj Kopernik, ki je zasnoval heliocentricni sistem in nenadoma nismo bili ravno najpomembnejsa stvar v vesolju, vsaj kar se tice gibanja planetov ne, bili pa smo kar pomembni v vseh drugih pogledih.`}</p>
    <p>{`Trenutno je clovestvo v stanju, ko misli, da je najrazvitejsa oblika v zivljenju, kar pa se mi zdi preprosto smesno, ker ni osnovano na nicemer drugem kot necimrnosti in pojmovanju, da smo kralji nasega planeta, ceprav niti tega se nismo popolnoma raziskali.`}</p>
    <p>{`Problem lezi v dejstvu, da se je v znanosti dolgo pojmovalo, da je Zemlja edini planet primeren za zivljenje in ko ji prislo do NLPjev in podobnega, se je vse potisnilo v pripovedke in znanstveno fantastiko. Prepican sem, da vecina takih pojavov niso vesoljci, ker ko pomislis, kaj kmalu ugotovis, da ce so bitja tako razvita, da nas sploh lahko dosezejo, zakaj bi nas pravzaprav hotela? Ljudje tudi ne delajo prijateljev iz mravelj.`}</p>
    <p>{`Tezava je v tem, da tudi opremljeni s tem dejstvom, na drugih planetih se vedno iscemo samo znake nekega bakterijskega zivljenja ali celo samo fosilne ostanke le-tega, v upanju, da bomo s tem dokazali obstoj zivljenja na drugih planetih. Ampak ali ni to rahlo neumno? Iskati dokaz, da smo se vedno najbolj razvita rasa v vesolju, medtem ko ne moremo niti na drug planet, kaj sele osoncje.`}</p>
    <p><a parentName="p" {...{
        "href": "http://video.google.com/videoplay?docid=-3974466981713172831"
      }}>{`Ta video`}</a>{`, se mi zdi, kaze kako nepomembni pravzaprav smo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      